import React, { Component, type ComponentType } from 'react';
import type { Action } from '../../services/types';
import { createDispatcherOld, type DispatcherProps } from './create-dispatcher';

type Props<TState, TAction extends Action> = {
	storeKey: string;
} & DispatcherProps<TState, TAction>;

type State<TState, TAction extends Action> = {
	DispatcherComponent: ComponentType<DispatcherProps<TState, TAction>> | null;
	lastStoreKey?: string;
};

// eslint-disable-next-line jira/react/no-class-components
export class Dispatcher<TAction extends Action, TState> extends Component<
	Props<TState, TAction>,
	State<TState, TAction>
> {
	static defaultProps = {
		storeKey: 'store',
	};

	static getDerivedStateFromProps<TAction extends Action, TState>(
		props: Props<TState, TAction>,
		state: State<TState, TAction>,
	) {
		if (props.storeKey === state.lastStoreKey) {
			return null;
		}

		return {
			lastStoreKey: props.storeKey,
			DispatcherComponent: createDispatcherOld(props.storeKey),
		};
	}

	state: State<TState, TAction> = { DispatcherComponent: null };

	render() {
		const { DispatcherComponent } = this.state;
		const { storeKey, ...dispatcherProps } = this.props;
		return DispatcherComponent && <DispatcherComponent {...dispatcherProps} />;
	}
}
